// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/systems/core/plugins

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function LayoutFeatureSection(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'LayoutFeatureSection',
      'aria-hidden': true,
      focusable: false,
      width: 64 * scale,
      height: 64 * scale,
      viewBox: '0 0 64 64',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement('path', {fill: 'currentColor', d: 'M34 23h24v4H34z'}),
    createElement('path', {
      opacity: '.5',
      fill: 'currentColor',
      d: 'M34 31h20v2H34zm0 4h20v2H34zm0 4h12v2H34z',
    }),
    createElement('path', {d: 'M6 20h24v24H6V20z', fill: 'currentColor'})
  );
}
